export default __webpack_public_path__ + "static/hero.light-905927320e83d1ae1afb1e28495e0cb46eb8a3476f23b46d9af334db2ccb7f4e.png";